"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Utils = require("./Utils");
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _constant = require("@airasia/phoenix-components/components/Theme/constant");
var _BigPointToBeEarned = _interopRequireDefault(require("@airasia/phoenix-components/components/BigPointToBeEarned"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Promo = _styledComponents.default.div.withConfig({
  displayName: "Promos__Promo",
  componentId: "sc-10u0zud-0"
})(["height:40%;color:#2f73d2;justify-content:center;padding-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
});
var QuarentinePromo = _styledComponents.default.div.withConfig({
  displayName: "Promos__QuarentinePromo",
  componentId: "sc-10u0zud-1"
})(["height:40%;color:#2f73d2;display:flex;flex-direction:column;justify-content:center;padding-bottom:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.small;
});
var BigPointsPromo = _styledComponents.default.div.withConfig({
  displayName: "Promos__BigPointsPromo",
  componentId: "sc-10u0zud-2"
})(["display:flex;justify-content:space-around;font-style:normal;font-weight:normal;font-size:", ";line-height:150%;padding-top:", ";padding-right:", ";margin-left:auto;padding-left:", ";text-align:justify;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSize.XSmall;
}, function (_ref4) {
  var theme = _ref4.theme,
    salesTag = _ref4.salesTag,
    promoTag = _ref4.promoTag;
  if (!promoTag) return theme.space.XXXSmall;
  if (!salesTag) return theme.space.semiXLarge;
  return theme.space.XXXSmall;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.space.small;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.semi;
});
var SalesTagQuarentine = _styledComponents.default.div.withConfig({
  displayName: "Promos__SalesTagQuarentine",
  componentId: "sc-10u0zud-3"
})(["display:flex;justify-content:center;align-items:center;margin-left:auto;background:#2f73d2;color:#ffffff;min-width:81px;height:26px;font-style:normal;font-weight:600;border-radius:4px;margin-top:20px;font-size:", ";line-height:150%;padding:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.XSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.small);
});
var LabelText = _styledComponents.default.div.withConfig({
  displayName: "Promos__LabelText",
  componentId: "sc-10u0zud-4"
})(["translate:-4px;"]);
var SalesTag = _styledComponents.default.div.withConfig({
  displayName: "Promos__SalesTag",
  componentId: "sc-10u0zud-5"
})(["display:flex;align-items:center;justify-items:center;height:auto;font-style:normal;font-weight:500;background:", ";color:", ";font-size:", ";padding:", ";"], function (_ref9) {
  var theme = _ref9.theme,
    background = _ref9.background;
  return theme.backgroundColor[background];
}, function (_ref10) {
  var theme = _ref10.theme,
    color = _ref10.color;
  return theme.colors[color];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSize.XSmall;
}, function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.small);
});
var BigPointsWrapper = _styledComponents.default.div.withConfig({
  displayName: "Promos__BigPointsWrapper",
  componentId: "sc-10u0zud-6"
})(["margin-top:", ";display:flex;margin-left:10%;align-items:center;justify-content:flex-end;color:#4c4c50;"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.space.tiny;
});
var QuarentineDiscountType = 'quarantine_deal';
var Promos = function Promos(_ref14) {
  var bigPointPromo = _ref14.bigPointPromo,
    salesTag = _ref14.salesTag,
    promoTag = _ref14.promoTag,
    promoTitle = _ref14.promoTitle,
    discountType = _ref14.discountType,
    theme = _ref14.theme,
    bigPoint = _ref14.bigPoint,
    isHotel = _ref14.isHotel,
    isBogoPromoEnabled = _ref14.isBogoPromoEnabled;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var showPromo = false;
  var ShowableText = showPromo ? promoTag : salesTag;
  var background = showPromo ? 'secondaryLight' : 'blueLight';
  var color = showPromo ? 'secondary' : 'blue';
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _Utils.isNotEmpty)(discountType) && discountType === QuarentineDiscountType ? /*#__PURE__*/_react.default.createElement(QuarentinePromo, null, (0, _Utils.isNotEmpty)(salesTag) && /*#__PURE__*/_react.default.createElement(SalesTagQuarentine, null, (0, _Utils.isNotEmpty)(promoTitle) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ShowableText) : ShowableText), (0, _Utils.isNotEmpty)(bigPointPromo) && (!isHotel ? /*#__PURE__*/_react.default.createElement(BigPointsPromo, {
      salesTag: salesTag,
      promoTag: promoTag
    }, bigPointPromo) : /*#__PURE__*/_react.default.createElement(BigPointsWrapper, null, /*#__PURE__*/_react.default.createElement(_BigPointToBeEarned.default, {
      template: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.template,
      pointTemplate: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.pointTemplate,
      pointValue: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.pointValue,
      multiplierTemplate: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.multiplierTemplate,
      multiplierValue: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.multiplierValue,
      customProperties: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.customProperties,
      isHotel: isHotel
    })))) : /*#__PURE__*/_react.default.createElement(Promo, {
      salesTag: salesTag
    }, (0, _Utils.isNotEmpty)(salesTag) && !isBogoPromoEnabled && /*#__PURE__*/_react.default.createElement(SalesTag, {
      background: background,
      color: color
    }, (0, _Utils.isNotEmpty)(promoTitle) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(LabelText, null, ShowableText)) : ShowableText), (0, _Utils.isNotEmpty)(bigPointPromo) && (!isHotel ? /*#__PURE__*/_react.default.createElement(BigPointsPromo, {
      salesTag: salesTag,
      promoTag: promoTag
    }, bigPointPromo) : /*#__PURE__*/_react.default.createElement(BigPointsWrapper, null, /*#__PURE__*/_react.default.createElement(_BigPointToBeEarned.default, {
      template: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.template,
      pointTemplate: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.pointTemplate,
      pointValue: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.pointValue,
      multiplierTemplate: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.multiplierTemplate,
      multiplierValue: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.multiplierValue,
      customProperties: bigPoint === null || bigPoint === void 0 ? void 0 : bigPoint.customProperties,
      isHotel: isHotel
    })))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
Promos.propTypes = {
  bigPointPromo: _propTypes.default.string,
  salesTag: _propTypes.default.string,
  promoTitle: _propTypes.default.string,
  promoTag: _propTypes.default.string,
  theme: _propTypes.default.string,
  discountType: _propTypes.default.string,
  isHotel: _propTypes.default.bool,
  bigPoint: _propTypes.default.instanceOf(Object),
  isBogoPromoEnabled: _propTypes.default.bool
};
Promos.defaultProps = {
  bigPointPromo: null,
  salesTag: null,
  promoTitle: null,
  promoTag: null,
  theme: _constant.DEFAULT_THEME,
  discountType: null,
  isHotel: false,
  bigPoint: null,
  isBogoPromoEnabled: false
};
var _default = Promos;
exports.default = _default;